// extracted by css-extract-rspack-plugin
export default {"property":"_IBHeH1fYU0MIY5P__property___","propertyInline":"KqnWzV2AqYAwrXdt__propertyInline___","title":"xShVBqml2GEycDsu__title___","divider":"ShN0TrIAl8JLayCL__divider___"};